"use client"

import { useCallback, useEffect, useRef, useState } from "react"
import ModalConfigurarImpresora from "./ModalConfigurarImpresora.js"
import { setPrinterConfigHandler } from "../../context/tickeadora/printerConfigBridge.js"

/**
 * Host global: registra el opener del bridge para que printerService
 * pueda pedir el número de impresora con el mismo modal React.
 */
export default function PrinterConfigModalHost() {
  const [open, setOpen] = useState(false)
  const [options, setOptions] = useState({})
  const resolveRef = useRef(null)

  const finish = useCallback((result) => {
    const resolve = resolveRef.current
    resolveRef.current = null
    setOpen(false)
    setOptions({})
    if (resolve) resolve(result)
  }, [])

  useEffect(() => {
    setPrinterConfigHandler((opts = {}) => {
      return new Promise((resolve) => {
        // Si ya hay uno abierto, cancelar el anterior
        if (resolveRef.current) {
          resolveRef.current({ cancelled: true })
        }
        resolveRef.current = resolve
        setOptions(opts)
        setOpen(true)
      })
    })
    return () => setPrinterConfigHandler(null)
  }, [])

  return (
    <ModalConfigurarImpresora
      open={open}
      mode={options.mode || "configure"}
      suggestedPrinterNumber={options.suggestedPrinterNumber}
      idUbicacion={options.idUbicacion}
      ubicaciones={options.ubicaciones}
      onSaved={(result) => finish(result)}
      onClose={(result) => finish(result || { cancelled: true })}
    />
  )
}
